import { useEffect, useState, useRef } from "react";

// PLACEHOLDER CLIENT LOGOS - Uncomment and replace with actual logos when ready
// const clients = [
//   { name: "The Grand Hotel", logo: "/path-to-logo.png" },
//   { name: "Maison Café", logo: "/path-to-logo.png" },
//   { name: "Azure Resort & Spa", logo: "/path-to-logo.png" },
//   { name: "Bistro Lumière", logo: "/path-to-logo.png" },
//   { name: "The Velvet Lounge", logo: "/path-to-logo.png" },
//   { name: "Horizon Hotels", logo: "/path-to-logo.png" },
// ];

const clientNames = [
  "The Grand Hotel",
  "Maison Café",
  "Azure Resort & Spa",
  "Bistro Lumière",
  "The Velvet Lounge",
  "Horizon Hotels"
];

const ClientLogosSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="clients" className="clients-section" ref={sectionRef} data-testid="clients-section">
      <div className={`clients-content ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
        <span className="clients-label">Trusted By</span>
        <h2 className="clients-title">Partners Who Believe in Scent</h2>
        
        <div className="clients-grid">
          {clientNames.map((name, index) => (
            <div 
              key={index} 
              className="client-logo-placeholder"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`client-logo-${index}`}
            >
              {/* Replace with actual logo: <img src={clients[index].logo} alt={name} /> */}
              <span className="client-name">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogosSection;
